import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Button, Paper, Grid } from '@mui/material';
import { obterPeriodo, excluirPeriodo } from '../../services/periodoService';

const DetalhesPeriodoPage = () => {
  const [periodo, setPeriodo] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPeriodo = async () => {
      try {
        const data = await obterPeriodo(id);
        setPeriodo(data);
      } catch (error) {
        console.error('Erro ao buscar detalhes do período:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    };

    fetchPeriodo();
  }, [id]);

  const handleExcluir = async () => {
    if (window.confirm('Tem certeza que deseja excluir este período?')) {
      try {
        await excluirPeriodo(id);
        navigate('/periodos');
      } catch (error) {
        console.error('Erro ao excluir período:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    }
  };

  if (!periodo) {
    return <Typography>Carregando...</Typography>;
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {periodo.nome}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography><strong>Campanha:</strong> {periodo.campanha?.nome}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography><strong>Total de Pré-Inscrições:</strong> {periodo.preInscricoes?.length || 0}</Typography>
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(`/periodos/editar/${id}`)}
        sx={{ mt: 2, mr: 1 }}
      >
        Editar
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={handleExcluir}
        sx={{ mt: 2 }}
      >
        Excluir
      </Button>
    </Paper>
  );
};

export default DetalhesPeriodoPage;